const otpEmail = {
  subject: 'Enkratno geslo:',
  body: {
    title: 'Vaše enkratno geslo za prijavo v VoiceFill Medical:',
    expiration: 'Geslo velja 15 minut.',
  },
};

export default otpEmail;
